import {Component, Input} from '@angular/core';
import {ControllerComponent} from '../../../../Controller/controller-component';

@Component({
  selector: 'app-provider-product-item',
  templateUrl: './provider-product-item.component.html',
  styleUrls: ['./provider-product-item.component.scss'],
  standalone: false
})
export class ProviderProductItemComponent extends ControllerComponent {
  @Input() image: string = '';
  @Input() title: string = '';
  @Input() format: string = '';
  @Input() cost: number = 0;
  @Input() finalCost: number = 0;
  @Input() discount: number = 0;
}
